<template>
  <div>
    <McButton
      @click="showModal = !showModal"
      variant="secondary"
      :text="$t('report.object.saveReport')"
      icon="icon-outline_bookmark"
    />
    <b-modal
      v-model="showModal"
      :title="$t('report.object.saveReport')"
      class="mc-modal"
      size="md"
      centered
    >
      <div class="mb-3">
        <b-form-input
          id="reportName"
          :placeholder="$t('report.object.reportName')"
          v-model.trim="reportName"
          trim
          :class="{
            'is-invalid': (!requiredReport || !requiredLetter) && isSubmit,
          }"
        />
        <b-form-invalid-feedback v-if="!requiredReport">
          {{ $t('report.object.reportNameFeedback') }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!requiredLetter">
          {{ $t('report.object.reportNameLettersRequired') }}
        </b-form-invalid-feedback>
      </div>
      <div class="mb-3">
        <b-form-textarea
          id="description"
          :placeholder="$t('report.object.reportDescription')"
          v-model.trim="description"
          trim
          :class="{
            'is-invalid': (!validDescription || !requiredIncludesAlphabet) && isSubmit,
          }"
        />
        <b-form-invalid-feedback v-if="!validDescription">
          {{ $t('report.object.validDescription') }}
        </b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!requiredIncludesAlphabet">
          {{ $t('report.object.requiredIncludesAlphabet') }}
        </b-form-invalid-feedback>
      </div>
      <template #modal-footer>
        <McButton variant="primary" :text="$t('global.action.save')" @click="handleAccept" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import { CREATE_SAVED_REPORT } from '@/services/api/report/report'

export default {
  components: {
    McButton,
  },
  props: {
    report: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
    },
    detail: {
      type: Object,
    },
  },
  data() {
    return {
      showModal: false,
      reportName: '',
      description: '',
      isSubmit: false,
    }
  },
  computed: {
    dateType() {
      return this.filter.dateType
    },
    filterReport() {
      return { ...this.filter, detail: this.detail }
    },
    requiredReport() {
      return this.reportName.length > 0 && this.reportName.length <= 100
    },
    validDescription() {
      return this.description.length > 0 && this.description.length <= 200
    },
    requiredLetter() {
      return /^[a-zA-Z0-9& ]+$/.test(this.reportName)
    },
    requiredIncludesAlphabet() {
      return /[a-zA-Z]/.test(this.description)
    },
  },
  methods: {
    async handleAccept() {
      if (
        this.requiredReport &&
        this.requiredLetter &&
        this.validDescription &&
        this.requiredIncludesAlphabet
      ) {
        const input = {
          filter: JSON.stringify(this.filterReport),
          reportKey: this.report.key,
          reportName: this.reportName,
          description: this.description,
        }
        if (this.dateType) {
          input.dateType = this.dateType
        }
        const createData = await this.$apollo.mutate({
          mutation: CREATE_SAVED_REPORT,
          variables: {
            input: input,
          },
        })
        if (createData.data.createSavedReport.isSuccessful) {
          this.$mcToast.success(this.$t('report.text.reportSuccessSaved'))
        } else if (createData.data.createSavedReport.message.includes('already exist')) {
          this.$mcToast.error(this.$t('report.text.alreadyExist'))
        } else {
          this.$mcToast.error(this.$t('report.text.reportFailedSaved'))
        }
        this.showModal = false
      }
      this.isSubmit = true
    },
  },
}
</script>
